import { GET_STARTED_URL, INSHUR_SIGNUP_ENABLED } from "./InshurHero";

/* "Claim Free Rentid Account" (Vish, 2026-10-01), repeated through /inshur. Same
   destination and the same INSHUR_SIGNUP_ENABLED switch as the hero button. */
export function InshurClaimCta({ align = "center", className = "" }) {
    const cls = "btn-pulse inline-flex items-center justify-center rounded-full px-7 py-4 text-center text-base font-semibold text-black transition-colors duration-200 hover:bg-[#2be0a8] active:scale-95 sm:py-3.5 sm:text-sm";
    return (<div className={`flex w-full ${align === "center" ? "justify-center" : "justify-start"} ${className}`}>
      {INSHUR_SIGNUP_ENABLED ? (<a href={GET_STARTED_URL} className={cls} style={{ backgroundColor: "#33F7BE" }}>
        Claim Free Rentid Account
      </a>) : (<button type="button" disabled aria-disabled="true" title="Coming soon" data-href={GET_STARTED_URL} className="inline-flex cursor-not-allowed items-center justify-center rounded-full px-7 py-4 text-center text-base font-semibold text-black opacity-50 sm:py-3.5 sm:text-sm" style={{ backgroundColor: "#33F7BE" }}>
        Claim Free Rentid Account
      </button>)}
    </div>);
}
